import { render, staticRenderFns } from "./ReceiveNote.vue?vue&type=template&id=4123e65a&"
import script from "./ReceiveNote.vue?vue&type=script&lang=js&"
export * from "./ReceiveNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports